// Form validation for New Project form
import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config)
};
